// URL de l'API : injectée au build via la variable Vite `VITE_API_URL`
// (cf. Dockerfile ARG VITE_API_URL et la CI qui la passe par environnement —
// QA vs prod). Repli sur le backend local pour le développement.
//
// Exemples :
//   - prod : VITE_API_URL=https://api.drtoho.com/lacompassion-server
//   - QA   : VITE_API_URL=https://api-test.drtoho.com/lacompassion-server
const config = {
  API: import.meta.env.VITE_API_URL || "http://localhost:4000/lacompassion-server",
};

export default config;
